/**
 * @generated SignedSource<<998e99aed3f47bb6b340ce8b7a8b3f57>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedAboutItemPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_user" | "PdpRespSimilarSoldItems_user">;
  readonly " $fragmentType": "PdpRespSharedAboutItemPanel_user";
};
export type PdpRespSharedAboutItemPanel_user$key = {
  readonly " $data"?: PdpRespSharedAboutItemPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedAboutItemPanel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    },
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItems_user"
            }
          ]
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4dbbff6b14ee9494b887e669bcce3f1a";

export default node;
